import React from 'react';

import { useHelpCategories } from '../../../../api/help-categories';
import MainTextSection from './components/section';
import './mainText.scss';

const MainText = () => {

    const categories = useHelpCategories();
    const midpoint = Math.ceil(categories.length / 2);
    const columns = [categories.slice(0, midpoint), categories.slice(midpoint)];

    return (
        <div className='main-text'>
            {columns.map((column, columnIndex) => (
                <ul className='main-text__column' key={columnIndex === 0 ? 'left' : 'right'}>
                    {column.map((category) => (
                        <MainTextSection
                            key={category.documentId}
                            title={category.name}
                            to={`/${category.slug}`}
                        />
                    ))}
                </ul>
            ))}
        </div>
    )
};

export default MainText;
